import { IStyle } from '@fluentui/merge-styles';

import { IH2OTheme } from '../../models/components.models';
import {} from '../../themes/styles';

export interface IPaginationStyles {
  root: IStyle;
  items: IStyle;
  item: IStyle;
  itemText: IStyle;
}

const gap = 8;

export const paginationStylesDefault = (theme: IH2OTheme): Partial<IPaginationStyles> => ({
  root: {
    position: 'relative',
    height: '100%',
    padding: '9px 0',
    textAlign: 'center',
  },
  items: {
    display: 'inline-flex',
    height: '100%',
  },
  item: {
    cursor: 'pointer',
    '&.circle': {
      width: 16,
      height: 16,
      borderRadius: 16,
      border: 0,
      transition: 'background-color 0.3s ease-in-out',
      outline: 0,
      padding: 0,
      backgroundColor: theme.palette?.gray300,
    },
    '&.circle.selected': {
      backgroundColor: theme.palette?.primary500,
    },
    '&.circle .h2o-Pagination-itemText': {
      display: 'none',
    },
    marginRight: gap,
  },
  itemText: {},
});
